// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.email.HpApiUserEmailUpdateV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type { HpApiResponseDto, HpEmailUpdateConfirmDto, HpEmailUpdateRequestDto, HpUserCredentialsDto } from '../..';

export const HpApiUserEmailUpdateV3Handler_confirm_Path = '/api/web/v3/user/email/update/confirm';

/**
 * Step 2 of the two-step email update flow. Checks the one-time code against the pending EmailUpdateRequest, then changes the email. Removes any linked Google or Apple sign-in, signs out every other session and emails both addresses
 */
export const HpApiUserEmailUpdateV3Handler_confirm = (postData: HpEmailUpdateConfirmDto, client = getClient()) => {
  return httpApiRequest<never, HpEmailUpdateConfirmDto, HpApiResponseDto<HpUserCredentialsDto>>(
    {
      endpoint: HpApiUserEmailUpdateV3Handler_confirm_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiUserEmailUpdateV3Handler_request_Path = '/api/web/v3/user/email/update/request';

/**
 * Step 1 of the two-step email update flow. Validates the caller's current password, checks that the new email is not already in use, persists an EmailUpdateRequest record for the user (invalidating any prior in-flight request), and sends an OTP to the new address.
 */
export const HpApiUserEmailUpdateV3Handler_request = (postData: HpEmailUpdateRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpEmailUpdateRequestDto, HpApiResponseDto<boolean>>(
    {
      endpoint: HpApiUserEmailUpdateV3Handler_request_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};
